import React, { Component } from "react";
import { Outlet } from "react-router-dom";
import Navbar from "../component/givBee/navbar/Navbar";
import Event from "../component/givBee/eventText/Event";
import store from "../redux/store";
import "./AdminApplicationLayout.css";
import EventSidebar from "../component/givBee/sidebar/EventSidebar";
// import TopMenus from "../component/givBee/topMenus/TopMenus";
class ApplicationEventLayout extends Component {
  businessDomainId = store.getState().businessDomain?.businessDomainId;
  constructor(props) {
    super(props);
    this.state = { isOpen: true, showOfflinePopup: false };
  }

  handleClick = (isOpenState) => {
    this.setState({ isOpen: isOpenState });
  };

  render() {
    return (
      <>
        <div className="layout-wrapper layout-navbar-full layout-horizontal layout-without-menu fixed-top">
          <Navbar />
        </div>
        <div id="application-layout">
          {/* <div
            className="row fixed-top"
            style={{ backgroundColor: "#fff", marginTop: "63px" }}
          >
            <TopMenus />
          </div> */}
          <div
            className="layout-wrapper layout-content-navbar"
            style={{ marginTop: "62px" }}
          >
            <div className="layout-container">
              <EventSidebar handleClick={this.handleClick} />
              <div
                className={
                  this.state.isOpen
                    ? "layout-page eventLayoutOpen"
                    : "layout-page eventLayoutClose"
                }
              >
                <Event
                  action="view"
                  props={this.props}
                  eventId={this.businessDomainId}
                />
                <div className="content-wrapper pt-4">
                  <div className="container-fluid flex-grow-1 container-p-y ps-3">
                    <Outlet />
                  </div>
                  <footer
                    className="content-footer footer primaryColor"
                    style={{ color: "#fff" }}
                  >
                    <div className="container-xxl d-flex flex-wrap justify-content-between py-2 flex-md-row flex-column">
                      <div className="mb-2 mb-md-0">
                        <span style={{ fontSize: "12px" }}>
                          Copyright (c) 2025 GivBee, LLC. All rights reserved.
                        </span>
                      </div>
                      <div className="text-end" style={{ fontSize: "12px" }}>
                        <a
                          href="/terms-conditions"
                          className="footer-link me-4"
                          target="_blank"
                          style={{ color: "#fff" }}
                        >
                          Terms &amp; Conditions
                        </a>
                        <a
                          href="/privacy-policy"
                          target="_blank"
                          className="footer-link me-4"
                          style={{ color: "#fff" }}
                        >
                          | &nbsp; Privacy Policy
                        </a>

                        <a
                          href="/"
                          target="_blank"
                          className="footer-link me-4"
                          style={{ color: "#fff" }}
                        >
                          |&nbsp; About Us
                        </a>
                      </div>
                    </div>
                  </footer>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
export default ApplicationEventLayout;
